// Vessel classification system
//
// Top-level kind: tank or barrel_keg
// Tank subtypes (multi-select): storage, ferm_open_top, ferm_closed_top
// Barrel/keg subtypes: TBD — to be added later

export const VESSEL_KINDS = [
  { value: 'tank', label: 'Tank' },
  { value: 'barrel_keg', label: 'Barrel / Keg' },
] as const;

export type VesselKind = 'tank' | 'barrel_keg';

export const TANK_SUBTYPES = [
  { value: 'storage', label: 'Storage' },
  { value: 'ferm_open_top', label: 'Ferm — Open Top' },
  { value: 'ferm_closed_top', label: 'Ferm — Closed Top' },
] as const;

export type TankSubtype = 'storage' | 'ferm_open_top' | 'ferm_closed_top';

export function formatVesselKind(kind: string | null | undefined): string {
  return VESSEL_KINDS.find(k => k.value === kind)?.label ?? 'Unknown';
}

export function formatTankSubtype(subtype: string): string {
  return TANK_SUBTYPES.find(s => s.value === subtype)?.label ?? subtype;
}

export function formatVesselSubtypes(subtypes: string[] | null | undefined): string {
  if (!subtypes?.length) return '';
  return subtypes.map(formatTankSubtype).join(', ');
}

// ─── Legacy shims ────────────────────────────────────────────────────────────
// Kept so existing callers don't break while being migrated away.

/** @deprecated Use vessel_kind / vessel_subtypes instead */
export function getMainCategories(): { value: string; label: string }[] {
  return VESSEL_KINDS.map(k => ({ value: k.value, label: k.label }));
}

/** @deprecated No-op; subtypes are now stored in vessel_subtypes[] */
export function getSubtypesForCategory(_categoryValue: string): { value: string; label: string }[] {
  return [];
}

/** @deprecated Use formatVesselKind / formatVesselSubtypes instead */
export function formatVesselType(typeValue: string): string {
  return VESSEL_KINDS.find(k => k.value === typeValue)?.label ?? typeValue;
}

/** @deprecated vessel_kind replaces the old category system */
export function getCategoryForSubtype(subtypeValue: string): string | null {
  if (subtypeValue === 'tank') return 'tank';
  if (subtypeValue === 'barrel_keg') return 'barrel_keg';
  return null;
}

/** @deprecated Use formatVesselKind instead */
export function getCategoryLabel(categoryValue: string): string {
  return formatVesselKind(categoryValue);
}
